import Navbar from '../components/cummon/Navbar';

import Footer from '../components/cummon/Footer';
import Contact from '../components/contact/contactSection';




function ContactPage() {
  return (
    <div className="min-h-screen  bg-white">
      <Navbar />
       
        <Contact />
      
      <Footer />
      
    
    
    </div>
  );
}

export default ContactPage;